import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { PersonalDataForm } from '../../forms/personal-data.form';
import { PaymentTypeEnum } from '../../models/payment-type.model';
import { FormControl } from '@angular/forms';
import { Brand } from '../../models/brand.model';
import { PaymentSummary } from '../../models/payment-summary.model';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit, OnChanges {
  PaymentTypeEnum = PaymentTypeEnum;

  @Input() personalDataForm: PersonalDataForm;
  @Input() imojeTosControl: FormControl<boolean>;
  @Input() imojeTosVisible: boolean;
  @Input() submitReady: boolean;
  @Input() submitted: boolean;
  @Input() brand: Brand;
  @Input() paymentSummary: PaymentSummary;
  @Output() formSubmitted = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  submit() {
    this.formSubmitted.emit();
  }

  ngOnChanges(): void {}
}
